// When the user clicks on the button, open the modal 
jQuery('#bold-btn').on('click', function(event) {
   event.preventDefault();
   jQuery('#bold-modal').show();
});

// When the user clicks on <span> (x), close the modal
jQuery('#bold-modal .close').on('click', function() {
   jQuery('#bold-modal').hide();
});

// When the user clicks anywhere outside of the modal, close it
jQuery(window).on('click', function(event) {
  var modal = document.getElementById('bold-modal');
  if (event.target == modal) {
    jQuery('#bold-modal').hide();
  }
});

jQuery('.fsBody .fsSubmitButton').on('click', function(e){
  e.preventDefault();
  
  var hasEmptyValue  = false;
  jQuery('.fsPage:not(.fsHiddenPage) select.fsField.fsRequired').each(function () {
    var val = jQuery(this).val();
 
    if (val == '') {
      hasEmptyValue = true;
    }
  });
 
  if (!hasEmptyValue) {
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: jQuery('.product-form').serialize(),
      success: function(response){
        HYRETAIN.clearValues();
        jQuery('.fsBody .fsSubmitButton').closest('form').submit();
      },
      error: function(data){
        alert('Something went wrong! Please refresh the page and try again');
      }
    });
  } else {
    // Submit anyways since this will fail and trigger the validation error messages.
    jQuery('.fsBody .fsSubmitButton').closest('form').submit();
  }
});

function formswitcher(sku){
  $('#form-content .reg-form').css('display','none');
  $('#form-content .'+sku).css('display','block');
};